// extracted by mini-css-extract-plugin
module.exports = {"termsButton":"TermsAndConditionsModal-TermsButton-module--terms-button--3UZU7"};